import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  orderBy,
  FirestoreError,
} from 'firebase/firestore';
import { firestore } from '../../config/firebase';
import { QuizResult } from '@e-learning/shared/src/store/types';

/**
 * Save quiz result to Firestore
 */
export const saveQuizResult = async (
  result: QuizResult,
  courseCategory?: string,
  difficulty?: 'beginner' | 'intermediate' | 'advanced' | 'mastery',
  userName?: string,
  userEmail?: string
): Promise<string> => {
  try {
    const resultsRef = collection(firestore, 'quizResults');
    const docRef = await addDoc(resultsRef, {
      userId: result.userId,
      courseId: result.courseId,
      quizId: result.quizId,
      score: result.score,
      totalQuestions: result.totalQuestions,
      correctCount: result.correctCount,
      questions: result.questions,
      timestamp: result.timestamp,
      completionStatus: result.completionStatus,
      courseCategory: courseCategory || '',
      difficulty: difficulty || 'intermediate',
      userName: userName || null,
      userEmail: userEmail || null,
    });
    return docRef.id;
  } catch (error) {
    const firestoreError = error as FirestoreError;
    throw new Error(`Failed to save quiz result: ${firestoreError.message}`);
  }
};

/**
 * Fetch quiz results for a user
 */
export const fetchQuizResultsByUserId = async (userId: string): Promise<QuizResult[]> => {
  try {
    const resultsRef = collection(firestore, 'quizResults');
    const q = query(
      resultsRef,
      where('userId', '==', userId),
      orderBy('timestamp', 'desc')
    );
    const querySnapshot = await getDocs(q);
    
    const results: QuizResult[] = [];
    querySnapshot.forEach((docSnapshot) => {
      const data = docSnapshot.data();
      results.push({
        id: docSnapshot.id,
        userId: data.userId,
        courseId: data.courseId,
        quizId: data.quizId,
        score: data.score,
        totalQuestions: data.totalQuestions,
        correctCount: data.correctCount,
        questions: data.questions || [],
        timestamp: data.timestamp,
        completionStatus: data.completionStatus,
      } as QuizResult);
    });
    
    return results;
  } catch (error) {
    const firestoreError = error as FirestoreError;
    throw new Error(`Failed to fetch quiz results: ${firestoreError.message}`);
  }
};

